<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <div class="row p-1">
      <div *ngFor="let v of consulta?.lista; let i = index" class="col-6 col-sm-4 col-md-3 col-xl-2 p-1 d-flex w-100">
        <div class="bloco-desvalorizacao border-info">
          <div class="bg-info text-white fw-500 titulo-ano">{{v.anoReferencia}}</div>
          <div class="f-14 bold">{{v?.valorAno ? (v.valorAno | currency:'R$ ') : 'NÃO INFORMADO'}}</div>
          <div *ngIf="this.consulta.lista[i].anoModelo == this.consulta.lista[i].anoReferencia " class="km-0 fw-500 f-28 text-info bg-light">0KM</div>
          <div *ngIf="i<consulta?.lista.length" class="f-14 fw-500 bg-light">
            <i class="mdi mr-1" [ngClass]="{
                      'mdi-arrow-up-bold-circle text-success': v?.porcentagemRelativaAnoAnterior > 0,
                      'mdi-arrow-down-bold-circle text-warning': v?.porcentagemRelativaAnoAnterior < 0,
                      'mdi-minus-circle text-info': v?.porcentagemRelativaAnoAnterior == 0
                    }"></i>
            <span>{{v?.porcentagemRelativaAnoAnterior}}%</span>
          </div>
          <div *ngIf="i>0" class="f-14 bold">
            <i class="mdi text-success mr-1" [ngClass]="{
                      'mdi-arrow-up-bold-circle text-success': v?.porcentagemRelativaValor0km > 0,
                      'mdi-arrow-down-bold-circle text-warning': v?.porcentagemRelativaValor0km < 0,
                      'mdi-minus-circle text-info': v?.porcentagemRelativaValor0km == 0
                    }"></i>
            <span>{{v?.porcentagemRelativaValor0km}}%</span>
          </div>
        </div>
      </div>
    </div>

  </ng-container>

</app-card-consulta>
